import React, { memo } from 'react';
import { NodeToolbar } from '@xyflow/react';

export default memo(({ data, children }) => {
  return (
    <div>
      <NodeToolbar
        isVisible={true}
        position='top'
        style={{
          backgroundColor: `${data.classColor?.light}`,
          color: data.classColor?.contrastText,
          borderRadius: '0',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '2rem',
          fontSize: 'small',
          cursor: 'grab',
          userSelect: 'none',
        }}
      >
        {data.label}
      </NodeToolbar>
      {/* Group content */}
      {children}
    </div>
  );
});
